var map = {
	"./bmr-demon.png": 4189,
	"./bmr-minion.png": 5372,
	"./bmr-outsider.png": 7887,
	"./bmr-townsfolk.png": 4389,
	"./bmr.png": 799,
	"./custom.png": 2487,
	"./luf.png": 8249,
	"./scrg.png": 9137,
	"./snv-demon.png": 8633,
	"./snv-minion.png": 7240,
	"./snv-outsider.png": 4259,
	"./snv-townsfolk.png": 5665,
	"./snv.png": 1499,
	"./tb-demon.png": 5502,
	"./tb-minion.png": 7201,
	"./tb-outsider.png": 2042,
	"./tb-townsfolk.png": 7774,
	"./tb.png": 904,
	"./tb2.png": 4712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7413;